import React, { useState } from 'react';
import { Icon, Modal } from 'semantic-ui-react';
import Button from '../../../../../../components/Button';
import { sendEmailLender } from '../../../../../../services/bond-insurance';
import { dangerNotification } from '../../../../../../services/notification';

interface LenderModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LenderModal: React.FC<LenderModalProps> = ({
  isOpen,
  onClose
}: LenderModalProps) => {
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);
  const [onSubmit, setOnSubmit] = useState<boolean>(false);

  const handleSubmit = async () => {
    setOnSubmit(true);
    try {
      const send = await sendEmailLender();
      if (!send.status) {
        dangerNotification('Erro', send.message);
        setOnSubmit(false);
        return;
      }
      setOnSubmit(false);
      setHasSubmitted(true);
    } catch (err) {
      dangerNotification('Erro', 'Erro ao enviar a solicitação.');
      setOnSubmit(false);
    }
  };

  const DocumentDownload = () => {
    return (
      <>
        <div style={{ width: '100%', height: '600px' }}>
          <iframe
            src="/documents/prestamista-hdi.pdf"
            width="100%"
            height="100%"
            title="PDF Viewer"
            style={{ border: 'none' }}
          />
        </div>
        <p style={{ marginTop: '12px' }}>
          <a
            href="/documents/prestamista-hdi.pdf"
            style={{ color: '#59249B', fontWeight: 'bold', cursor: 'pointer' }}
            download
          >
            <Icon className="download" /> Clique aqui
          </a>{' '}
          para baixar o regulamento.
        </p>
      </>
    );
  };

  const TextSuccess = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <p style={{ color: '#59249B', fontWeight: 'bold', fontSize: '20px' }}>
          Agora é com a gente!
        </p>
        <p>
          Em breve, nossa equipe entrará em contato com você para tirar todas as suas
          dúvidas e dar continuidade à sua solicitação.
        </p>
      </div>
    );
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      size={hasSubmitted ? 'small' : 'large'}
      closeIcon
    >
      <Modal.Header>
        <Icon className="file alternate outline" />
        Prestamista LadoBom
      </Modal.Header>
      <Modal.Content>
        {hasSubmitted ? <TextSuccess /> : <DocumentDownload />}
      </Modal.Content>
      <Modal.Actions>
        <div
          style={{
            display: 'flex',
            justifyContent: hasSubmitted ? 'end' : 'space-between',
            width: '100%'
          }}
        >
          <div>
            <Button
              fluid
              color="grey"
              type={'button'}
              text="Fechar"
              style={{
                margin: '0.5em 0em',
                paddingLeft: '36px',
                paddingRight: '36px'
              }}
              onClick={() => onClose()}
            />
          </div>
          {!hasSubmitted && (
            <div>
              <Button
                fluid
                disabled={onSubmit}
                type={'button'}
                text="Quero experimentar"
                style={{
                  margin: '0.5em 0em',
                  paddingLeft: '36px',
                  paddingRight: '36px'
                }}
                onClick={() => handleSubmit()}
              />
            </div>
          )}
        </div>
      </Modal.Actions>
    </Modal>
  );
};

export default LenderModal;
